import React from 'react';

function About() {
  return (
    <div className="container py-5">
      <h2 className="text-center mb-4 text-danger">About Us</h2>
      <p className="text-center text-muted">
        Learn more about our company, mission, and the passionate team that drives our success.
      </p>
    </div>
  );
}

export default About;
